/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as EnIndexRouteImport } from './routes/en.index'
import { Route as EnAboutRouteImport } from './routes/en.about'
import { Route as ArticlesSlugRouteImport } from './routes/articles.$slug'
import { Route as EnArticlesSlugRouteImport } from './routes/en.articles.$slug'

const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const EnIndexRoute = EnIndexRouteImport.update({
  id: '/en/',
  path: '/en/',
  getParentRoute: () => rootRouteImport,
} as any)
const EnAboutRoute = EnAboutRouteImport.update({
  id: '/en/about',
  path: '/en/about',
  getParentRoute: () => rootRouteImport,
} as any)
const ArticlesSlugRoute = ArticlesSlugRouteImport.update({
  id: '/articles/$slug',
  path: '/articles/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const EnArticlesSlugRoute = EnArticlesSlugRouteImport.update({
  id: '/en/articles/$slug',
  path: '/en/articles/$slug',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/articles/$slug': typeof ArticlesSlugRoute
  '/en/about': typeof EnAboutRoute
  '/en/': typeof EnIndexRoute
  '/en/articles/$slug': typeof EnArticlesSlugRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/articles/$slug': typeof ArticlesSlugRoute
  '/en/about': typeof EnAboutRoute
  '/en': typeof EnIndexRoute
  '/en/articles/$slug': typeof EnArticlesSlugRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/articles/$slug': typeof ArticlesSlugRoute
  '/en/about': typeof EnAboutRoute
  '/en/': typeof EnIndexRoute
  '/en/articles/$slug': typeof EnArticlesSlugRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/articles/$slug'
    | '/en/about'
    | '/en/'
    | '/en/articles/$slug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/articles/$slug'
    | '/en/about'
    | '/en'
    | '/en/articles/$slug'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/articles/$slug'
    | '/en/about'
    | '/en/'
    | '/en/articles/$slug'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  ArticlesSlugRoute: typeof ArticlesSlugRoute
  EnAboutRoute: typeof EnAboutRoute
  EnIndexRoute: typeof EnIndexRoute
  EnArticlesSlugRoute: typeof EnArticlesSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/en/': {
      id: '/en/'
      path: '/en'
      fullPath: '/en/'
      preLoaderRoute: typeof EnIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/en/about': {
      id: '/en/about'
      path: '/en/about'
      fullPath: '/en/about'
      preLoaderRoute: typeof EnAboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/articles/$slug': {
      id: '/articles/$slug'
      path: '/articles/$slug'
      fullPath: '/articles/$slug'
      preLoaderRoute: typeof ArticlesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/en/articles/$slug': {
      id: '/en/articles/$slug'
      path: '/en/articles/$slug'
      fullPath: '/en/articles/$slug'
      preLoaderRoute: typeof EnArticlesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  ArticlesSlugRoute: ArticlesSlugRoute,
  EnAboutRoute: EnAboutRoute,
  EnIndexRoute: EnIndexRoute,
  EnArticlesSlugRoute: EnArticlesSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
